// extracted by mini-css-extract-plugin
module.exports = {"img-fluid":"+oyFw","img-thumbnail":"-eGwE","figure":"_2Kyqa","figure-img":"fo1IX","figure-caption":"_8fp8O"};